import { useCallback, useEffect } from 'react';
import {
  SaveToSnowflakeContext,
  SaveToSnowflakeWriteMode,
} from '@scale/genai-compass-shared/cards/save_to_snowflake';
import { useCompassCard } from '@scale/compass-ui/store';

const useSaveToSnowflake = (
  index: number,
): {
  setTableName: (tableName?: string) => void;
  setWriteMode: (writeMode: SaveToSnowflakeWriteMode) => void;
} => {
  const { card, updateCardContext, updateCardCanSubmit } = useCompassCard(index);
  const context = card.defaultContext as SaveToSnowflakeContext;

  const setTableName = useCallback(
    (tableName?: string) => {
      const updatedContext: SaveToSnowflakeContext = { ...context, tableName };
      updateCardContext(updatedContext);
    },
    [context, updateCardContext],
  );

  const setWriteMode = useCallback(
    (writeMode: SaveToSnowflakeWriteMode) => {
      const updatedContext: SaveToSnowflakeContext = { ...context, writeMode };
      updateCardContext(updatedContext);
    },
    [context, updateCardContext],
  );

  useEffect(() => {
    if (context.tableName && context.tableName.length > 0) {
      updateCardCanSubmit(true);
    } else {
      updateCardCanSubmit(false);
    }
  }, [context.tableName]);

  return {
    setTableName,
    setWriteMode,
  };
};

export default useSaveToSnowflake;
